import {
  LightWeightObjectChangeTracker,
  SetOptions
} from '@schoolbelle/common/object-change-tracker';
import { OptionBaseInterface } from './option.base.interface';
import { Question } from '../../question';
import { OptionDataInterface } from './optionData.interface';
import { pick } from 'lodash';
import { setPriority } from '../../../functions';

export class OptionBase extends LightWeightObjectChangeTracker
  implements OptionBaseInterface, OptionDataInterface {
  get id(): string {
    return this.get(['id']);
  }
  get text(): string {
    return this.get(['text']);
  }
  set text(v: string) {
    this.set(['text'], v);
  }
  get type(): string {
    return this.get(['type']);
  }
  set type(v: string) {
    this.set(['type'], v);
  }
  get priority(): number {
    return this.get(['priority']);
  }
  set priority(v: number) {
    this.setOptionPriority(v);
  }
  get quota(): number {
    return this.get(['quota']);
  }
  set quota(v: number) {
    this.set(['quota'], v);
  }
  get value(): OptionDataInterface {
    return pick(this.get([]), ['id', 'text', 'type', 'priority', 'quota']);
  }

  constructor(public question: Question, option_id: string) {
    super(question, ['options', option_id]);
    this.set('id', option_id, { push: 'none' });
  }
  /**
   *
   * @param data
   * @param options
   * if no priority is set, set 1000, which will be modified to a proper value to put the question at the end of question list.
   * id, type, and priority are preset and should not be overriden.
   */
  public load(
    data: Partial<OptionDataInterface> = {},
    options: SetOptions = undefined
  ) {
    //overide
    if (typeof data.priority === 'undefined')
      this.setOptionPriority(1000, { push: 'none' });
    else this.setOptionPriority(data.priority, { push: 'none' });

    this.set(
      [],
      {
        ...data,
        id: this.id,
        priority: data.priority || this.priority
      },
      { push: 'none' }
    );
    this.notifyChangeThruTree([], options);
  }
  private setOptionPriority(
    v_n: number,
    options: SetOptions = undefined
  ): void {
    setPriority(this, this.question.options, v_n, options);
  }
}
